<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GaLoSt/tc-custom/9781623954734.jpg?1701477060368" alt="This image is the cover for the book I Love You!, Xist Children's Books"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I Love You!, Xist Children's Books
      </h1>
      <p class="bookDescription body article font2">
        <b>A heartwarming, rhyming picture book, perfect for teaching little ones about love as they learn how to read.</b><br/><br/>“I love you like a skipping stone . . . I love you like a doggy’s bone . . .”<br/><br/>Celebrating the love between a parent and a child, this rhyming book features a host of animals and the things they love about each other. Perfect for babies, toddlers, preschoolers and as a reminder to the big kids in your life.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Calee M. Lee, Tricia Tharp
      </h2>
      
      <p class="authorDescription body article">Calee M. Lee loves forest walks, city bakeries and 3-book weekends. She is the author of more that 15 children's books and the reader of at least 15,000. She lives with her husband, 2 children, and cat in Southern California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      www.redjumper.net/bookcreator
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b0b6be6